import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import React from 'react';

type Prop = {
  indentLevel?: number;
  hideAmount?: boolean;
  fact: string;
  amount: number;
  adornment?: string;
  unit: string;
  // Can be null for facts, such as Net Carbs and Total Sugars
  pctDailyValue: number | null;
};

const NutritionFactRow: React.FC<Prop> = ({
  indentLevel = 0,
  fact,
  amount,
  hideAmount,
  adornment,
  unit,
  pctDailyValue,
}) => {
  const isItalic = !!adornment;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: `${indentLevel * 16}px`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          gap: '3px',
        }}
      >
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: indentLevel === 0 ? 800 : undefined,
            fontStyle: isItalic ? 'italic' : undefined,
          }}
        >
          {fact}
        </Typography>
        {!hideAmount ? (
          <>
            <Typography
              sx={{
                fontSize: '13px',
                fontStyle: isItalic ? 'italic' : undefined,
              }}
            >
              {amount}
              {unit}
            </Typography>
            <sup style={{ fontStyle: isItalic ? 'italic' : undefined }}>
              {adornment}
            </sup>
          </>
        ) : null}
      </Box>
      {pctDailyValue !== null ? (
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 800,
          }}
        >
          {pctDailyValue}%
        </Typography>
      ) : null}
    </Box>
  );
};

export default NutritionFactRow;
